<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{
              user && user.customer_id ? "Editar" : "Cadastrar"
            }}
            Cliente</span
          >
          <v-spacer />
          <span style="padding-right: 10px">{{
            user ? user.customer_id : ""
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Nome Completo"
                  v-model="name"
                  type="text"
                  required
                  :hint="nome_titular"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o seu nome',
                    (v) =>
                      v.length >= 10 || 'Por favor, preencha o nome completo.',
                  ]"
                ></v-text-field>
                <input
                  type="hidden"
                  name="nome_titular"
                  v-model="nome_titular"
                />
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  read-only
                  hint="E-mail principal do cliente"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o email',
                    (v) =>
                      /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                        v,
                      ) || 'E-mail precisa ser válido',
                  ]"
                  name="email"
                  :disabled="user.customer_id ? true : false"
                  type="email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="tel"
                  v-model="phone"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o celular',
                    (v) =>
                      v.length > 10 ||
                      'Ops. Parece que esse não é um número de telefone',
                  ]"
                  prepend-icon="phone"
                  return-masked-value
                  mask="(##)#####-####"
                  label="Telefone"
                  hint="Preferencialmente um telefone com whatsapp"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  id="cpf"
                  v-model="cpf"
                  autofocus
                  label="CPF/CNPJ"
                  mask="###.###.###-##"
                  :rules="[
                    (v) => !!v || 'Por favor, informe seu CPF!',
                    (v) => this.validaCPF(this.cpf) === true || 'CPF inválido',
                  ]"
                  required
                  @change="buscaDadosComplementares($event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-progress-circular
                  v-if="loading_cpf"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  id="rg"
                  v-model="rg"
                  label="Documento"
                  hint="RG ou outro oficial"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o documento',
                    (v) =>
                      v.length > 7 ||
                      'Ops. Parece que esse não é um número valido',
                  ]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  id="orgao_expeditor"
                  v-model="orgao_expeditor"
                  label="Orgão Expeditor"
                  hint="ex. SSP/MG"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, informe o orgao expeditor do documento',
                  ]"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Data de Nasc"
                  v-model="birthday"
                  required
                  mask="##/##/####"
                  :rules="[
                    (v) => !!v || 'Por favor, informe a data de nascimento',
                    (v) =>
                      v.length > 9 ||
                      'Ops. Parece que esse não é um data valida',
                  ]"
                  return-masked-value
                ></v-text-field>
              </v-flex>
              <!-- <v-flex  xs12 sm6 md4>
								<v-text-field label="Password*" type="password" required></v-text-field>
							</v-flex> -->
              <v-flex xs12 sm6 md1>
                <v-select
                  :items="['M', 'F']"
                  label="Sexo"
                  v-model="gender"
                  :rules="[(v) => !!v || 'Por favor, informe o sexo']"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <!-- <v-autocomplete
									:items="profissoes.profissoes"
									label="Profissao"
									v-model="profissao"
									:rules='[
										v => !!v || "Por favor, informe a profissão ou escolha \"outra\"",
									]'
								></v-autocomplete> -->
                <v-text-field
                  label="Profissao"
                  v-model="profissao"
                  type="text"
                  required
                  :rules="[(v) => !!v || 'Por favor, informe a profissão']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  :items="marital_status"
                  item-value="value"
                  item-text="text"
                  label="Estado Civil"
                  v-model.lazy="marital_status_value"
                  :rules="[
                    (v) => !!v || 'Por favor, selecione o estado civil!',
                  ]"
                  :hint="'Selecione o estado civil'"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  v-if="marital_status_value === 'Casado(a)'"
                  :items="marital_type"
                  item-text="text"
                  item-value="value"
                  label="Regime de Bens"
                  v-model.lazy="marital_type_value"
                  :rules="[
                    (v) => !!v || 'Por favor, selecione o regime de bens!',
                  ]"
                  :hint="'Selecione o regime de bens'"
                  required
                ></v-autocomplete>
                <div v-else>N/A</div>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  id="consumer_unit"
                  v-model="consumer_unit"
                  label="Numero de Instalação CEMIG"
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  id="cep"
                  v-model="cep"
                  label="CEP"
                  mask="#####-###"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o CEP do cliente',
                    (v) =>
                      v.length > 7 ||
                      'Ops. Parece que esse não é um CEP válido',
                  ]"
                  @change="buscaCep($event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-progress-circular
                  v-if="loading_cep"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  id="logradouro"
                  v-model="logradouro"
                  label="Logradouro"
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  id="numero"
                  v-model="numero"
                  label="Núm."
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  id="complemento"
                  v-model="complemento"
                  label="Complemento"
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  id="bairro"
                  v-model="bairro"
                  label="Bairro"
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  id="localidade"
                  v-model="localidade"
                  label="Cidade"
                  hint="opcional"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-autocomplete
                  :items="states"
                  item-text="name"
                  item-value="initials"
                  label="Estado"
                  prepend-icon="map"
                  v-model="state"
                  return-object
                  :rules="[(v) => !!v || 'Por favor, selecione o seu estado!']"
                  :hint="'Selecione o estado'"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-select
                  :items="payment_type_items"
                  item-value="value"
                  item-text="text"
                  label="Metodo de Pagamento*"
                  v-model="payment_type"
                  :rules="[
                    (v) => !!v || 'Por favor, informe o método de pagamento',
                  ]"
                  required
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false"
            >fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="!valid || loading"
            @click.prevent="validate"
            type="submit"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-form>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../main";
import lista_profissoes from "../../utils/profissoes.json";
import statesfile from "@/model/state";
import { getCEP } from "../../services/getCep";
import { getPEOPLE } from "../../services/getPeople";
import { storeCustomer } from "../../services/users";
import { updateLead, addLead } from "../../services/leads";
import { saveAnalytics } from "../../services/save_analytics";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      dialog: false,
      valid: false,
      profissoes: lista_profissoes,
      lead: {},
      cadLead: "new",
      name: "",
      nome_titular: "",
      phone: "",
      email: "",
      average: "",
      cpf: "",
      rg: "",
      birthday: "",
      mother_name: "",
      orgao_expeditor: "",
      user: {},
      marital_status: [
        { text: "Solteiro(a)", value: "Solteiro(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Separado(a)", value: "Separado(a)" },
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Viúvo(a)", value: "Viúvo(a)" },
      ],
      marital_status_value: "",
      marital_type: [
        { text: "Comunhão Universal de Bens", value: "Universal de bens" },
        { text: "Comunhão Parcial de Bens", value: "Parcial de bens" },
        { text: "Separação Total de Bens", value: "Separação total" },
        {
          text: "Participação Final nos Aquestos",
          value: "Final nos aquestos",
        },
      ],
      marital_type_value: "",
      gender: "",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      localidade: "",
      uf: "",
      state: {
        initials: "MG",
        name: "Minas Gerais",
      },
      profissao: "",
      consumer_unit: "",
      states: statesfile.estados,
      payment_type_items: [
        { text: "Cartão de Crédito", value: "credit_card" },
        { text: "Boleto", value: "boleto" },
      ],
      payment_type: "",
      loading: false,
      loading_cpf: false,
      loading_cep: false,
      color: null,
      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
    };
  },
  created() {
    // console.log('created createCustomer')
    var vm = this;
    eventBus.$on("dialog", function (value) {
      vm.dialog = value;
    });
    // this.lead = {}
    // this.user = {}
    // console.log('this.loggedUser: ', this.loggedUser)
  },
  // beforeDestroy(){
  // 	console.log('beforeDestroy')
  // },
  // destroyed(){
  // 	console.log('destroyed')
  // },
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  mounted() {
    eventBus.$on("Lead", (lead) => {
      // console.log('mounted createCustomer')
      this.lead = {};
      this.user = {};
      this.loading = true;
      if (lead) {
        this.lead = lead;
        this.cadLead = "edit";
        if (lead.user) {
          this.user = lead.user;
          this.name = lead.user.name;
          this.email = lead.user.email;
          this.phone = lead.user.phone.split("+55")[1];
          this.average = lead.user.average_consumption;
          this.cep = lead.user.postal_code;
          this.cpf = lead.user.cpf;
          if (lead.user.ID_document) {
            let rg = lead.user.ID_document.split("-")[0];
            let org = lead.user.ID_document.split("-")[1];
            this.rg = rg;
            this.orgao_expeditor = org;
          }
          this.birthday = this.reverseDate(lead.user.date_of_birth);
          this.gender = lead.user.gender;
          this.profissao = lead.user.profession;
          this.marital_type_value = lead.user.marital_type;
          this.marital_status_value = lead.user.marital_status;
          this.consumer_unit = lead.user.installation_number;
          this.mother_name = lead.user.mother_name;
          if (lead.user.address) {
            this.cep = lead.user.address.postal_code;
            this.logradouro = lead.user.address.address;
            this.numero = lead.user.address.address_number;
            this.complemento = lead.user.address.address_complement;
            this.bairro = lead.user.address.district;
            this.localidade = lead.user.address.city;
            this.state = lead.user.address.state;
          }
          this.payment_type = lead.user.payment_type;
        } else {
          this.user = {};
          this.clearUser();
          if (lead.name) {
            this.name = lead.name;
            this.email = lead.email;
            this.phone = lead.phone;
            this.average = lead.average_consumption;
            this.cep = lead.postal_code;
          }
        }
      } else {
        this.clearUser();
      }
      this.loading = false;
    });
  },
  methods: {
    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            // console.log(result)
            ((this.logradouro = result.data.logradouro),
              (this.numero = result.data.numero));
            this.complemento = result.data.complemento;
            this.bairro = result.data.bairro;
            this.localidade = result.data.localidade;
            this.uf = result.data.UF;
            this.loading_cep = false;
            // this.snack('OK: ' + error, 'red', 'top')
          })
          .catch((error) => {
            this.snack(
              "Erro ao buscar o CEP informado. Erro: " + error,
              "red",
              top,
            );
            this.loading_cep = false;
          });
      }
    },
    buscaDadosComplementares(cpf) {
      if (cpf && cpf !== "" && this.validaCPF(cpf)) {
        this.loading_cpf = true;
        getPEOPLE(cpf)
          .then((result) => {
            if (result.data.BasicData) {
              ((this.nome_titular = result.data.BasicData.Name),
                (this.gender = result.data.BasicData.Gender));
              this.nacionalidade = result.data.BasicData.BirthCountry;
              this.mother_name = result.data.BasicData.MotherName;
              this.birthday = this.formatDate(result.data.BasicData.BirthDate);
            }
            if (result.data.ProfessionData) {
              this.profissao =
                result.data.ProfessionData.Professions[0].Level === "UNKNOWN"
                  ? ""
                  : result.data.ProfessionData.Professions[0].Level || "";
            }
            this.loading_cpf = false;
          })
          .catch((error) => {
            this.snack(
              "Erro ao buscar o CEP informado. Erro: " + error,
              "red",
              "top",
            );
            this.loading_cpf = false;
          });
      }
    },
    clearUser() {
      this.cadLead = "new";
      this.valid = false;
      this.user = {};
      this.lead = {};
      this.name = "";
      this.nome_titular = "";
      this.email = "";
      this.phone = "";
      this.average = "";
      this.cep = "";
      this.cpf = "";
      this.rg = "";
      this.birthday = "";
      this.gender = "";
      this.profissao = "";
      this.marital_type_value = "";
      this.marital_status_value = "";
      this.consumer_unit = "";
      this.mother_name = "";
      this.orgao_expeditor = "";
      this.cep = "";
      this.logradouro = "";
      this.numero = "";
      this.complemento = "";
      this.bairro = "";
      this.localidade = "";
      this.state = "";
      this.payment_type = "";
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    formatDate(value) {
      if (!value || value === "") return "";
      if (new Date(value)) {
        return moment.utc(new Date(value)).format("DD/MM/YYYY");
      } else {
        return value;
      }
    },
    validaCPF(strCPF) {
      if (!strCPF) return "";
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      if (strCPF == "11111111111") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    },
    validate() {
      if (this.$refs.form.validate()) {
        // console.log('cadLead: ', this.cadLead)
        let status = "QUALIFICAR";
        let termo_uso = "Sim";
        if (this.loggedUser.send_proposal) {
          status = "REQUEST_PROPOSAL";
          termo_uso = "Não";
        }
        // console.log('form: ', this.$refs.form)
        this.loading = true;
        let newUser = {
          name: this.name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: this.phone,
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state,
            city: this.localidade,
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average,
          cpf: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          installation_number: this.consumer_unit,
          nationality: this.nacionalidade,
          payment_type: this.payment_type,
          profession: this.profissao,
          mother_name: this.mother_name,
          requiredPSChange: 1,
          // signedcontract_at: new Date(),
          marital_status: this.marital_status_value,
          marital_type: this.marital_type_value,
        };
        // Se Proposta
        if (this.loggedUser.send_proposal) {
          if (!this.user.customer_id) {
            newUser.status = status;
            newUser.termouso = termo_uso;
            newUser.sale_by = "SUPER";
            newUser.sale_source = this.loggedUser.partner_id;
            newUser.sale_partner = this.loggedUser.email;
          }
          //SE JÁ POSSUIA USUÁRIO E O MEIO DE PAGAMENTO ESTIVER MUDANDO, SETA A DATA DE ESCOLHA DO BOLETO
          // console.log('newUser: ', newUser)
          storeCustomer(newUser)
            .then((user) => {
              // console.log('u: ', user)
              if (user.status === 200 && user.data.buyer_id && user.data.id) {
                if (!this.user.customer_id) {
                  // console.log('usuario novo')
                  if (this.cadLead === "edit") {
                    const data = {
                      termouso: "Nao",
                    };
                    // console.log('atualiza lead: ', data)
                    updateLead(this.email, data)
                      .then(() => {
                        // console.log('Lead atualizado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  } else {
                    const data = {
                      ...newUser,
                      termouso: "Nao",
                    };
                    // console.log('atualiza lead: ', data)
                    addLead(data)
                      .then(() => {
                        // console.log('Lead criado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  }
                  const analytics = {
                    eventCategory: "SUPER",
                    eventAction: "SALE-PARTNER",
                    eventLabel: this.loggedUser.partner_id || "enercred",
                    transaction_id: user.data.email,
                    value: user.data.average_consumption,
                    utm_source: "SUPER",
                    utm_medium: "phone",
                    utm_campaign: this.loggedUser.email,
                    boleto: false,
                  };
                  saveAnalytics(analytics);
                }
                this.user = user.data;
                this.lead.user = user.data;
                eventBus.$emit("Lead", this.lead);
                this.snack("Cliente gravado com sucesso!", "green", "top");
              } else {
                this.snack(
                  "Houve um erro inesperado. Procure nosso suporte!",
                  "red",
                  "top",
                );
              }
              this.loading = false;
            })
            .catch((error) => {
              console.error("Erro ao gravar usuário!", error.message);
              let err_msg = "Erro ao gravar cliente! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg, "red", "top");
              this.loading = false;
            });
        } else {
          // Se Venda
          if (!this.user.customer_id) {
            newUser.status = status;
            newUser.termouso = termo_uso;
            newUser.signedcontract_at = new Date();
            newUser.signedcontract_by = "SUPER";
            newUser.signedcontract_source = this.loggedUser.partner_id;
            newUser.signedcontract_partner = this.loggedUser.email;
          } else {
            if (!this.user.card_default && !this.user.boleto_accepted_at) {
              if (!newUser.signedcontract_at) {
                newUser.signedcontract_at = new Date();
                newUser.status = status;
                newUser.termouso = termo_uso;
              }
              newUser.signedcontract_by = "SUPER";
              newUser.signedcontract_source = this.loggedUser.partner_id;
              newUser.signedcontract_partner = this.loggedUser.email;
            }
          }
          //SE JÁ POSSUIA USUÁRIO E O MEIO DE PAGAMENTO ESTIVER MUDANDO, SETA A DATA DE ESCOLHA DO BOLETO
          if (
            this.user.customer_id &&
            this.user.payment_type !== "boleto" &&
            this.payment_type === "boleto"
          ) {
            ((newUser.boleto_accepted_at = new Date()),
              (newUser.boleto_accepted_by = "telefone"));

            //SE NÃO POSSUI USUARIO E A SELECAO É BOLETO
          } else if (!this.user.customer_id && this.payment_type === "boleto") {
            ((newUser.boleto_accepted_at = new Date()),
              (newUser.boleto_accepted_by = "telefone"));
          }
          // let historys = []
          if (!this.user.customer_id) {
            const history = {
              created_at: new Date(),
              user_id: this.loggedUser.email,
              action: "created",
            };
            newUser.history = [];
            newUser.history.push(history);
          } else {
            newUser.history = this.user.history || [];
            const history = {
              created_at: new Date(),
              user_id: this.loggedUser.email,
              action: "updated",
            };
            newUser.history.push(history);
          }
          // console.log('newUser: ', newUser)
          storeCustomer(newUser)
            .then((user) => {
              // console.log('u: ', user)
              if (user.status === 200 && user.data.buyer_id && user.data.id) {
                if (!this.user.customer_id) {
                  // console.log('usuario novo')
                  if (this.cadLead === "edit") {
                    // console.log('atualiza lead: ', newUser)
                    const data = {
                      signedcontract_at: new Date(),
                      signedcontract_by: "phone",
                      termouso: "Sim",
                      signedcontract_source: this.loggedUser.partner_id,
                      signedcontract_partner: this.loggedUser.email,
                    };
                    // console.log('atualiza lead: ', data)
                    updateLead(this.email, data)
                      .then(() => {
                        // console.log('Lead atualizado com sucesso')
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  } else {
                    // console.log('cria lead: ', newUser)
                    addLead(newUser)
                      .then(() => {
                        // console.log('Lead criado com sucesso: ', resLead)
                        return;
                      })
                      .catch((err) => {
                        console.error("Erro ao criar lead: ", err);
                      });
                  }

                  const analytics = {
                    eventCategory: "SUPER",
                    eventAction: "SIGN-CONTRACT",
                    eventLabel: this.loggedUser.partner_id || "enercred",
                    transaction_id: user.data.email,
                    value: user.data.average_consumption,
                    utm_source: "SUPER",
                    utm_medium: "phone",
                    utm_campaign: this.loggedUser.email,
                    boleto: true,
                  };
                  // console.log('analytics: ',analytics)
                  saveAnalytics(analytics);
                } else {
                  if (newUser.signedcontract_at) {
                    const analytics = {
                      eventCategory: "SUPER",
                      eventAction: "SIGN-CONTRACT",
                      eventLabel: this.loggedUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: "SUPER",
                      utm_medium: "phone",
                      utm_campaign: this.loggedUser.email,
                      boleto: true,
                    };
                    saveAnalytics(analytics);
                  }
                }

                this.user = user.data;
                this.lead.user = user.data;
                eventBus.$emit("Lead", this.lead);
                this.snack("Cliente gravado com sucesso!", "green", "top");
              } else {
                this.snack(
                  "Houve um erro inesperado. Procure nosso suporte!",
                  "red",
                  "top",
                );
              }
              this.loading = false;
            })
            .catch((error) => {
              console.error("Erro ao gravar usuário!", error.message);
              let err_msg = "Erro ao gravar cliente! Contate nosso suporte.";
              if (error.code === "auth/email-already-in-use") {
                err_msg = "Este email está sendo utilizado por outra conta.";
              }
              this.snack(err_msg + " - " + error, "red", "top");
              this.loading = false;
            });
        }
      }
    },
    reverseDate(date) {
      if (!date || date === "") return "";
      // console.log('dd: ', typeof(date))
      // console.log('dd: ', date)
      if (typeof date !== "string") {
        // console.log('date1: ', new Date(date))
        return moment.utc(new Date(date)).format("DD/MM/YYYY");
      } else {
        let ano = date.split("/")[2];
        let _ano = date.split("-")[0];

        if (_ano && _ano.length <= 4) {
          // console.log('_ano: ', _ano.length)
          // console.log('split: ', date.split('-'))
          let dia = "";
          if (date.split("-")[2]) {
            dia = date.split("-")[2].substring(0, 2);
          }
          let mes = date.split("-")[1];
          return dia + mes + _ano;
        } else if (ano && ano.length <= 4) {
          // console.log('ano: ', ano.length)
          let dia = "";
          if (date.split("/")[0]) {
            dia = date.split("/")[0].substring(0, 2);
          }
          let mes = date.split("/")[1];
          return dia + mes + ano;
        }

        // console.log('date2: ', date)
        return date;
      }
    },
  },
};
</script>
